import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Observable } from "rxjs";

@Component({
  selector: "app-validar-documento",
  templateUrl: "./validar-documento.component.html",
  styleUrls: ["./validar-documento.component.css"],
})
export class ValidarDocumentoComponent {
  documentos: any[];
  isReenviar: boolean;
  nroDocumentoReenviar: number
  isSolicitudEnviada: boolean;
  estado: string;

  displayedColumns = ["nroDocumento", "tipoDocumento", "estado"];

    constructor(
    public dialogRef: MatDialogRef<ValidarDocumentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Observable<any>
  ) {
    data.subscribe((res) => {
      this.documentos = res.documentos;
      this.isReenviar = res.habilitarReenviar;
      if (this.documentos) {
        this.nroDocumentoReenviar = this.documentos[0].numeroDocumento;
      }
      this.isSolicitudEnviada = res.solicitudEnviada;
      this.estado = res.documentos[0].estado;
    });
  }

  obtenerMensaje(): string {
    if (this.isSolicitudEnviada) {
      switch (this.estado) {
        case 'FIRMADO':
          return 'El documento fue firmado y la solicitud acaba de ser enviada.';
        case 'RECHAZADO':
        case 'RECHAZADO_ASESOR':
          return 'El documento fue rechazado y la solicitud acaba de ser enviada.';
        case 'ERROR':
          return 'El documento se encuentra en estado error y la solicitud acaba de ser enviada.';
        default:
          return '';
      }
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-negocios/shared/components/validar-documento/validar-documento.component.ts